/**
 * 생년월일에서 만 나이를 센다.
 *
 * 2023년 만 나이 통일법 이후 "N세"는 만 나이를 뜻한다. `올해 − 태어난 해`로 세면
 * 생일 전까지 한 살 높게 나오므로, 달과 날짜까지 비교해 생일이 안 지났으면 하나 뺀다.
 *
 * 한 제품 안에서 같은 대상자의 나이가 화면마다 다르면 안 된다 — 개요 헤더와
 * 케어플랜의 AI 입력이 이 하나를 함께 쓴다. 표기는 각자 한다(개요는 "N세",
 * 케어플랜은 "만 N세"). 두 번째 구현을 만들지 말 것.
 *
 * @param {string|Date|null|undefined} birthdate 생년월일. '-' 나 파싱 불가 값도 받는다.
 * @returns {number|null} 만 나이. 셀 수 없으면 null.
 */
export const calculateAge = (birthdate) => {
    if (!birthdate || birthdate === '-') return null;

    const born = new Date(birthdate);
    if (Number.isNaN(born.getTime())) return null;

    const today = new Date();
    let age = today.getFullYear() - born.getFullYear();
    const monthDiff = today.getMonth() - born.getMonth();
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < born.getDate())) {
        age -= 1;
    }

    return age;
};

export default calculateAge;
